import ScrollableSection from '@components/v2/layout/ScrollableSection/ScrollableSection';
import { useWorkspacePadding } from '@components/v2/layout/hooks/useWorkspacePadding';
import { Box, Stack } from '@mui/material';
import { Group, Panel } from 'react-resizable-panels';
import { useObjectDetailsPanelLayout } from '../hooks/useObjectDetailsPanelLayout';
import { OBJECT_CONTENT_PANEL_ID } from '../objectScreen.constants';
import { ObjectLayoutProps } from '../objectScreen.types';
import { ObjectDetailsSlot } from './ObjectDetailsSlot/ObjectDetailsSlot';

export const ObjectDefaultLayout = ({
  objectType,
  header,
  content,
  afterHeaderSlots,
  afterToolbarSlots,
  tabsRow,
  filterBar,
  afterFilterBarSlots,
  hasStickyFilterBar,
  details,
  setScrollParent,
  setStickyFilterBar,
}: ObjectLayoutProps) => {
  const { padding: workspacePadding } = useWorkspacePadding();
  const { defaultLayout, onLayoutChanged } = useObjectDetailsPanelLayout(objectType);

  const filterBarRegion = hasStickyFilterBar ? (
    <Box
      ref={setStickyFilterBar}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 3,
        flexShrink: 0,
        pb: 1.5,
        pl: workspacePadding,
        bgcolor: 'background.paper',
      }}
    >
      {filterBar}
    </Box>
  ) : (
    <Box sx={{ pl: workspacePadding }}>{filterBar}</Box>
  );

  return (
    <Stack sx={{ height: '100%', minHeight: 0, bgcolor: 'transparent' }}>
      {header}
      {afterHeaderSlots}
      {tabsRow}
      {afterToolbarSlots}
      <Stack
        direction="row"
        sx={{
          position: 'relative',
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          mx: -workspacePadding,
        }}
      >
        <Group
          orientation="horizontal"
          defaultLayout={defaultLayout}
          onLayoutChanged={onLayoutChanged}
        >
          <Panel
            id={OBJECT_CONTENT_PANEL_ID}
            style={{ display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}
          >
            <ScrollableSection
              ref={setScrollParent}
              bleed={false}
              sx={{ mb: 1, display: 'flex', flexDirection: 'column' }}
            >
              {filterBarRegion}
              {afterFilterBarSlots}
              <Box
                sx={{
                  flex: '1 0 auto',
                  display: 'flex',
                  flexDirection: 'column',
                  pl: workspacePadding,
                }}
              >
                {content}
              </Box>
            </ScrollableSection>
          </Panel>
          {details.panel && (
            <ObjectDetailsSlot
              panel={details.panel}
              isOpen={details.isOpen}
              isInlineOnTablet={details.isInlineOnTablet}
              onClose={details.onClose}
              onExpansionStepsChange={details.onExpansionStepsChange}
            />
          )}
        </Group>
      </Stack>
    </Stack>
  );
};
